// IE 2026 09 27 / ODOO-341407 (заказ Игоря 27.09: «в tooltip если язык не eng то дополнительно показывай название на англ»): АНГЛИЙСКОЕ ИМЯ рядом с
// переведённым названием в строке названия подсказки — «Пункт меню: Фільтри · Filters» (английское — приглушённым стилем, класс tip-en-name, App.vue).
// Где: плитка и группа рейла страниц, стол и категория списка столов (utils/tipActions.js), пункт и заголовок группы панелей-меню (MenuPanel: панель
// страниц, меню страницы, ≡ виджета / таблицы, меню пользователя, панель задач), кнопка командной панели (AttrButton, строка Action).
// Откуда английское (первый известный источник решает):
//   · en — явное английское от владельца подсказки (ключ группы страниц; 'Pages' для t('Pages'));
//   · raw — подпись, локализованная бэком (attrs._i18n_apply: пометка _i18n + бэкап '{key}_en' — title_en / node.valueStr_en …; i18nNames_enBackup);
//   · record — загруженная запись (стол, виджет): meta.title_en (английский вариант записи с не английской базой), иначе база title без кириллицы;
//   · id — запись по id: кэш стора menuTitles (бэк catalog_titles langs='all': суффикс meta.title_en, словарь en.json для кириллической базы, иначе база;
//     '' — английского имени нет). Нет в кэше — ОДИН запрос на пачку (id + соседи от владельца: весь рейл, вся панель, весь список столов), по приходу
//     видимая подсказка перерисовывается штатным повторным показом (uiHelp_reshow); запись показанным текстом по словарю не ищется (мнимые имена);
//   · ui — строка интерфейса t('English'): ключ словаря — обратная карта словаря языка показа (i18nNames_of; словарь грузится лениво — по приходу перерисовка).
// Английское совпадает с показанным, неизвестно или с кириллицей — ничего не добавляется; язык интерфейса en — ничего. Выключатель — настройка
// fe.i18n.tooltipEnName (по умолчанию вкл.; window.feSettings.set('fe.i18n.tooltipEnName', false) — подсказки как были); счётчики — window._tipEnName.stats
import { getLanguage, LANGUAGE_DEFAULT } from '@/i18n'
import { i18nNames_enBackup, i18nNames_of, i18nNames_hasLang, i18nNames_loadLang } from './i18nNames'
import { uiHelp_reshow } from './uiHelp.js'

const CYR_RE = /[А-Яа-яЁёІіЇїЄєҐґ]/
const stats = { asks: 0, hits: 0, fetches: 0, dictLoads: 0, reshows: 0 }
const clean = (v) => String(v ?? '').replace(/\s+/g, ' ').trim()
const escHtml = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')

// показывать ли английское: язык интерфейса не en и выключатель не снят
export function tipEn_on(store) {
    if (getLanguage() === LANGUAGE_DEFAULT) return false
    try { return !(store && typeof store.setting === 'function' && store.setting('fe.i18n.tooltipEnName', true) === false) } catch (e) { return true }
}
// кандидат: не пустой, не '-', без кириллицы; совпадает с показанным (без учёта регистра) — '' (добавлять нечего)
function _pick(en, shown) {
    const e = clean(en)
    if (!e || e === '-' || CYR_RE.test(e)) return ''
    return e.toLowerCase() === clean(shown).toLowerCase() ? '' : e
}
// английское имя загруженной записи: meta.title_en → база title без кириллицы; '' — не известно
export function tipEn_recordEn(record) {
    if (!record || typeof record !== 'object') return ''
    const m = record.meta && typeof record.meta === 'object' ? clean(record.meta.title_en) : ''
    if (m && !CYR_RE.test(m)) return m
    const b = clean(record.title)
    return (b && !CYR_RE.test(b)) ? b : ''
}
// источник пришёл (записи из catalog_titles, словарь языка) — видимая подсказка перерисовывается один раз
function _reshowWhen(p) {
    Promise.resolve(p).then((n) => { if (n) { stats.reshows++; uiHelp_reshow() } }).catch(() => { /* источник недоступен — подсказка без английского */ })
}
function _hit(v) { if (v) stats.hits++; return v }

// английское имя показанного названия: строка либо '' (ничего не добавлять); src: { en, raw, record, id, ids, store, ui }
export function tipEn_name(shown, src = {}) {
    const s = clean(shown)
    if (!s || !src) return ''
    const store = src.store || null
    if (!tipEn_on(store)) return ''
    stats.asks++
    if (src.en !== undefined && src.en !== null && clean(src.en)) return _hit(_pick(src.en, s))
    const bk = src.raw ? i18nNames_enBackup(src.raw) : ''
    if (bk && !CYR_RE.test(bk)) return _hit(_pick(bk, s))
    if (src.record) { const r = tipEn_recordEn(src.record); if (r) return _hit(_pick(r, s)) }
    if (src.id) {
        const id = String(src.id)
        if (!store || typeof store.menuTitles_get !== 'function') return ''
        const tt = store.menuTitles_get(id)
        if (tt) return _hit(_pick(tt.en, s))
        if (!(id in (store.menuTitles || {})) && typeof store.menuTitles_fetch === 'function') {
            let more = []
            try { more = (typeof src.ids === 'function' ? src.ids() : src.ids) || [] } catch (e) { more = [] }
            stats.fetches++
            _reshowWhen(store.menuTitles_fetch([id, ...more]))
        }
        return ''
    }
    if (src.ui) {
        const lang = getLanguage()
        if (!i18nNames_hasLang(lang)) { stats.dictLoads++; _reshowWhen(i18nNames_loadLang(lang)); return '' }
        let names = null
        try { names = i18nNames_of(s, lang) } catch (e) { names = null }
        return _hit(_pick(names && names.en, s))
    }
    return ''
}
// разметка английского имени — дописывается ПОСЛЕ значения строки подсказки (внутри <b class='tooltip-text'>); '' — нечего добавлять
export function tipEn_html(en) {
    const e = clean(en)
    return e ? `<span class='tip-en-name'> · ${escHtml(e)}</span>` : ''
}
// путь групп «A › B»: английское каждого звена (enOf(звено) → строка | ''); звено без английского и без кириллицы — как есть (латиница одинакова
// на обоих языках), с кириллицей — путь целиком неизвестен (''); путь совпал с показанным — ''
export function tipEn_chain(parts, enOf, sep = ' › ') {
    const list = (parts || []).map(clean).filter(Boolean)
    if (!list.length) return ''
    const out = []
    for (const p of list) {
        let e = ''
        try { e = clean(enOf(p)) } catch (err) { e = '' }
        if (!e) { if (CYR_RE.test(p)) return ''; e = p }
        out.push(e)
    }
    const en = out.join(sep)
    return en.toLowerCase() === list.join(sep).toLowerCase() ? '' : en
}

const tipEnName = { stats, on: tipEn_on, name: tipEn_name, html: tipEn_html, chain: tipEn_chain, recordEn: tipEn_recordEn }
if (typeof window !== 'undefined') window._tipEnName = tipEnName
export default tipEnName
